import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGithubLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "20pt",
	preserveAspectRatio: "xMidYMid meet",
	viewBox: "0 0 64 64",
	width: "64pt",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m214 630c-86-27-180-123-204-208-15-55-12-162 6-215 29-87 149-193 207-185 17 2 23 11 25 35 3 29 0 33-20 33-46 0-69 13-98 56-34 50-26 58 13 14 21-24 35-30 66-30 28 0 40 5 45 17 3 10 9 24 12 31 4 7-2 12-16 12-11 0-38 9-59 20-61 30-89 122-56 180 8 14 14 44 15 68 0 45 12 52 53 30 12-6 64-11 117-11s105 5 117 11c41 22 53 15 53-30 1-24 7-54 15-68 33-58 5-150-56-180-21-11-47-20-59-20-21 0-26-10-11-26 6-5 11-38 13-74 3-58 5-65 25-68 60-9 179 99 208 189 24 70 17 198-13 256-33 63-74 105-134 138-46 25-65 30-143 32-49 1-104-2-121-7z",
		transform: "matrix(.1 0 0 -.1 0 64)"
	})
});
export { SvgGithubLogo as ReactComponent };
